// Custom hook for wallet operations using Wagmi
// This provides convenient access to common wallet functionality

import { useAccount, useConnect, useDisconnect, useBalance, useChainId, useSwitchChain } from 'wagmi';

/**
 * Custom hook that provides wallet connection state and operations
 * @returns {Object} Wallet state and functions
 */
export function useWallet() {
  const { address, isConnected, connector } = useAccount();
  const { connect, connectors, isPending } = useConnect();
  const { disconnect } = useDisconnect();
  const chainId = useChainId();
  const { switchChain } = useSwitchChain();
  const { data: balance, isLoading: balanceLoading } = useBalance({
    address,
  });

  return {
    // Connection state
    address,
    isConnected,
    connector,
    chainId,
    
    // Balance
    balance: balance?.formatted,
    balanceSymbol: balance?.symbol,
    balanceLoading,
    
    // Actions
    connect,
    disconnect,
    switchChain,
    
    // Available connectors
    connectors,
    isConnecting: isPending,
  };
}

/**
 * Hook to get the current account address
 * @returns {string|null} The connected wallet address
 */
export function useWalletAddress() {
  const { address } = useAccount();
  return address;
}

/**
 * Hook to check if wallet is connected
 * @returns {boolean} True if wallet is connected
 */
export function useIsWalletConnected() {
  const { isConnected } = useAccount();
  return isConnected;
}

